// extracted by mini-css-extract-plugin
module.exports = {"infoDescription":"_3Xp38u5","infoValue":"_3qLj9y0"};